<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (ngSubmit)="login()" class="form-inline flex-nowrap">
    <div class="form-group">
        <input
                [(ngModel)]="username"
                autocomplete="username"
                class="form-control form-control-sm mr-sm-2"
                id="username"
                name="username"
                placeholder="{{ 'global.form.username.placeholder' | translate }}"
                type="text"
        />
    </div>
    <div class="form-group">
        <input
                [(ngModel)]="password"
                autocomplete="current-password"
                class="form-control form-control-sm mr-sm-2"
                id="password"
                name="password"
                placeholder="{{ 'login.form.password.placeholder' | translate }}"
                type="password"
        />
    </div>

    <button [disabled]="loginInProgress" type="submit" windeGreen>
        {{ 'login.form.button' | translate }}
    </button>

    <a (click)="resetPassword()" class="nav-link btn-reset-password">
        {{ 'navbar.resetPassword' | translate }}
    </a>
</form>
